export interface PausedBannerViewProps {
    visible: boolean;
}

const PausedBannerView: React.FC<PausedBannerViewProps> = ({ visible }) => {
    if (!visible) return null;

    return (
        <div
            className="w-full bg-red-600 text-white px-4 py-3 flex flex-col md:flex-row md:items-center gap-2"
            role="alert"
            data-testid="paused-banner"
        >
            <span
                className="relative inline-flex items-center justify-center mr-1"
                aria-hidden="true"
            >
                <span className="absolute inline-flex h-3 w-3 rounded-full bg-white opacity-75 animate-ping" />
                <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
            </span>
            <p className="flex-1 text-sm md:text-base">
                <span className="font-semibold">
                    Your service is suspended
                </span>{" "}
                — Access to your account is on hold due to a payment issue.
                Contact{" "}
                <a
                    href="mailto:billing@digitalawesomeapps.com"
                    className="underline"
                >
                    billing@digitalawesomeapps.com
                </a>{" "}
                to resolve this and restore your service.
            </p>
        </div>
    );
};

export default PausedBannerView;
